import React, { useState } from 'react';
import './HomePage.css';       // estilos globais
import './PrivacyPolicy.css';  // estilos exclusivos da página
import { Link } from 'react-router-dom';

/**
 * Página – Política de Privacidade
 * Última atualização: 2 de junho de 2025
 */
export default function PrivacyPolicy() {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen(!menuOpen);

  const currentYear = new Date().getFullYear();

  return (
    <div className="privacy-page">
      {/* HEADER (igual ao do HomePage) */}
      <header className="header">
        <nav className="navbar">
          <div className="logo">
            <a href="/">
              <img src="/imagens/logo.png" alt="Meicor Logo" />
            </a>
          </div>

          {/* Botão Hamburger */}
          <button className="hamburger" onClick={toggleMenu} aria-label="Abrir menu">
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </button>

          {/* Links – regressam à Home pelas âncoras */}
          <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
            <li><a href="/#about" onClick={() => setMenuOpen(false)}>Sobre</a></li>
            <li><a href="/#vision-mission" onClick={() => setMenuOpen(false)}>Visão &amp; Missão</a></li>
            <li><a href="/#contact" onClick={() => setMenuOpen(false)}>Contato</a></li>
            <li><a href="/#location" onClick={() => setMenuOpen(false)}>Localização</a></li>
            <li><Link to="/politica-privacidade" onClick={() => setMenuOpen(false)}>Política</Link></li>
          </ul>
        </nav>
      </header>

      {/* CONTEÚDO */}
      <section id="privacy" className="section policy-card">
        <h2>Política de Privacidade</h2>
        <p className="update-date">Última atualização: 2&nbsp;de&nbsp;junho&nbsp;de&nbsp;2025</p>

        <h3>1. Responsável pelo tratamento</h3>
        <p>
          <strong>MEICOR - Passamanarias, Lda.</strong> (NIF&nbsp;502&nbsp;674&nbsp;334), com sede em
          <strong> Estrada Lamas de Cima&nbsp;nº&nbsp;181, 4620-017 Aveleda-Lousada</strong>, é a entidade responsável pelo tratamento dos seus dados pessoais.
        </p>

        <h3>2. Que dados recolhemos?</h3>
        <p>
          Apenas recolhemos o seu <strong>nome</strong>, o <strong>endereço de e-mail</strong> e o conteúdo da <strong>mensagem</strong> submetida através do formulário de contacto.
        </p>

        <h3>3. Finalidade e base jurídica</h3>
        <p>
          Utilizamos estes dados exclusivamente para processar e responder ao seu pedido de contacto, ao abrigo do artigo&nbsp;6.º, n.º&nbsp;1, alínea&nbsp;b) (diligências pré-contratuais) ou alínea&nbsp;f) (interesse legítimo) do RGPD.
        </p>

        <h3>4. Destinatários</h3>
        <p>
          Os dados são processados temporariamente pelo nosso prestador de serviço de correio eletrónico e alojamento
          (<strong>DMNS - Domínios, S.A.</strong>) apenas para o reencaminhamento da mensagem. Não partilhamos os dados com quaisquer outros terceiros.
        </p>

        <h3>5. Prazo de conservação</h3>
        <p>
          <strong>Não armazenamos</strong> as suas mensagens em bases de dados nem em qualquer repositório permanente. Após o envio do e-mail, os dados são imediatamente apagados.
        </p>

        <h3>6. Direitos do titular</h3>
        <p>
          Enquanto o tratamento decorre (isto é, durante o envio da mensagem), pode solicitar <strong>confirmação</strong> de que os seus dados foram transmitidos com sucesso. Uma vez concluído o envio e eliminados os dados, deixamos de dispor de qualquer cópia para efeitos de <em>acesso</em>, <em>rectificação</em> ou <em>apagamento</em>. Caso pretenda entrar de novo em contacto, poderá submeter nova mensagem.
        </p>

        <h3>7. Reclamações</h3>
        <p>
          Pode apresentar reclamação à <strong>Comissão Nacional de Proteção de Dados (CNPD) em  </strong>
          <a href="https://www.cnpd.pt" target="_blank" rel="noopener noreferrer">www.cnpd.pt</a>.
        </p>

        <h3>8. Segurança</h3>
        <p>
          Implementamos medidas técnicas e organizativas adequadas (HTTPS e TLS) para proteger a transmissão dos seus dados contra acesso não autorizado.
        </p>

        <h3>9. Alterações a esta política</h3>
        <p>
          Poderemos atualizar esta política periodicamente. As alterações serão publicadas nesta página com data de revisão.
        </p>

        {/* NOTA FINAL DE CONTACTO */}
        <p className="contact-note mt-8">
          Se tiver alguma dúvida, contacte‑nos através do e‑mail&nbsp;
          <a href="mailto:meicor@live.com.pt">meicor@live.com.pt</a>. <br />
          <em>A gerência agradece a sua confiança.</em>
        </p>
      </section>

      {/* FOOTER */}
      <footer className="footer">
        <p>
          &copy; {currentYear} Meicor. Todos os direitos reservados. Feito com muito amor por&nbsp;
          <a href="https://www.linkedin.com/in/jos%C3%A9-pedro-meireles-alves-783a9994/" target="_blank" rel="noopener noreferrer">
            José&nbsp;Meireles
          </a>. ❤️
        </p>
      </footer>
    </div>
  );
}
